import { useLocationDependency } from './useLocationDependency'
import { useRoomConfigurationDependency } from './useRoomConfigurationDependency'
import { useTravelPeriodDependency } from './useTravelPeriodDependency'

export const useStepDependencies = () => {
	useLocationDependency()
	useRoomConfigurationDependency()
	useTravelPeriodDependency()
}
